<template>
  <div id="btnAddGoogleDriveLink">
    <v-menu
      v-model="menu"
      offset-x
      min-width="500px"
      close-on-click
      :close-on-content-click="false"
      attach="#btnAddGoogleDriveLink"
    >
      <template v-slot:activator="{ on }">
        <v-btn
          small
          class="ma-1"
          v-on="on"
        >
          Додати
        </v-btn>
      </template>
      <v-card>
        <v-card-text class="py-2">
          <v-row>
            <v-col class="pb-0">
              <CustomTextField
                v-model="link"
                label="Посилання на Google Drive"
              />
            </v-col>
          </v-row>
        </v-card-text>
        <v-card-actions class="pt-0">
          <v-spacer />
          <v-btn
            :disabled="!link"
            text
            color="primary"
            @click="add"
          >
            Ок
          </v-btn>
          <v-btn
            text
            @click="cancel"
          >
            Відмінити
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-menu>
  </div>
</template>

<script>
import CustomTextField from "../../../components/CustomTextField.vue";

export default {
  components: {
    CustomTextField,
  },
  data: () => ({
    link: null,
    menu: false,
  }),
  methods: {
    add() {
      this.$emit("add", this.link);
      this.cancel();
    },
    cancel() {
      this.link = null;
      this.menu = false;
    },
  },
};
</script>
